import styled from 'styled-components';

export const ContainerLabel = styled.div`
  margin: 10px 10px 20px 0px;
`;

export const Titulo = styled.h2`
  font-family: 'Roboto', 'Open Sans', 'sans-serif';
  text-align: center;
  font-weight: 800;
  font-size: 18pt;
  color: var(--primary-color-sefaz);
`;

export const FraseAcessoSolicitacao = styled.div`
  margin: 0 5px 30px 5px;
  padding: 10px;
  text-align: center;
  border-radius: 10px;
  -webkit-box-shadow: 0px 29px 41px -53px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 29px 41px -53px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 29px 41px -53px rgba(0, 0, 0, 0.75);

  button {
    margin: 5px;
  }

  i {
    font-size: 9pt;
  }

  .ant-row {
    justify-content: center;
  }
`;

export const TituloSolicitacao = styled.p`
  font-size: 13pt;
  margin-top: 10px;
  margin-bottom: 5px;
  text-align: center;
`;

export const ContainerRow = styled.div`
  margin-top: 46px;
  display: flex;
  justify-content: center;

  svg {
    font-size: 40pt;
    margin-top: 0px;
    color: var(--primary-color-sefaz);

    animation-name: tamanho;
    animation-duration: 4s;
    animation-iteration-count: infinite;

    @keyframes tamanho {
      0% {
        rotate: 30deg;
      }
      25% {
        rotate: -30deg;
      }
      50% {
        rotate: 30deg;
      }
      75% {
        rotate: -30deg;
      }
      100% {
        rotate: 30deg;
      }
    }
  }
`;
